export default __webpack_public_path__ + "static/media/loading.09c1f8ae.gif";